import { createContext } from "react";

export const ConfigContext = createContext({
    bootstrapConfig: {}
});